import ReportedContentListModal from './ReportedContentListModal';

export default ReportedContentListModal;
